<template>
  <!-- <el-dialog title="新建病程" :visible.sync="showNewCourse" width="500px" :before-close="handleClose" :modal-append-to-body="true" :close-on-click-modal="false"
    :append-to-body="true"> -->
  <div>
    <el-form ref="eventForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-suffix=":" size="small">
      <el-form-item label="病程时间" required>
        <el-form-item prop="eventDate">
          <el-date-picker v-model="ruleForm.eventDate" type="date" :picker-options="pickerOptions" placeholder="选择日期" class="common-sty" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form-item>

      <el-form-item label="治疗地点" prop="hospital">
        <!-- <el-input v-model="ruleForm.hospital" placeholder="请输入"></el-input> -->
        <el-autocomplete
          class="inline-input"
          v-model="ruleForm.hospital"
          :fetch-suggestions="querySearch"
          placeholder="请输入关键词搜索医院名称"
          style="margin-right:10px;width:100%"
          :trigger-on-focus="false"
        ></el-autocomplete>
      </el-form-item>

      <el-form-item label="治疗科室" prop="departmentName">
        <!-- <el-input v-model="ruleForm.departmentName" placeholder="请输入"></el-input> -->
        <el-autocomplete
          class="inline-input"
          style="width:100%"
          v-model="ruleForm.departmentName"
          :fetch-suggestions="queryDepartment"
          placeholder="请输入关键词搜索科室"
          :trigger-on-focus="false"
        ></el-autocomplete>
      </el-form-item>

      <el-form-item label="治疗类型" prop="eventName" v-if="ruleForm.eventName != '图文问诊'">
        <el-radio-group v-model="ruleForm.eventName">
          <el-radio label="门诊"></el-radio>
          <el-radio label="急诊"></el-radio>
          <el-radio label="住院"></el-radio>
          <el-radio label="院外"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="当前诊断">
        <el-input v-model.trim="ruleForm.diseaseName" maxlength="30" clearable></el-input>

        <!-- :disabled="(ruleForm.diseaseName && ruleForm.diseaseName != '其他') ? true : false" -->
        <!-- <el-select
          v-model="ruleForm.diseaseObj"
          style="width:100%"
          value-key="diseaseId" @change="diseaseNameChange"
          filterable
          remote
          reserve-keyword
          v-elSelectloadMore="loadmore"
          :remote-method="val => {remoteDieaseItemMethod(val)}">
          <el-option v-for="item in diseaseList" :key="item.diseaseId" :label="item.diseaseName" :value="item">
          </el-option>
        </el-select> -->
      </el-form-item>

      <!-- <el-form-item label="所属阶段">
        <el-cascader
          ref="therCascader"
          class="therCascader"
          style="width:100%"
          :options="therapyStageList"
          :props="therProps"
          v-model="therapyStageIdList"
          @change="changeTther"
        ></el-cascader>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeAddEvent" size="mini">取 消</el-button>
      <el-button type="primary" @click="handleAddEvent" size="mini">保 存</el-button>
    </div>
  </div>
  <!-- </el-dialog> -->
</template>
  
<script>
import {
  findDiseaseTypeByAdmin
} from "@/api/Patientmanagement.js";
import {
  getTherapyStageByDiseaseId
} from "@/views/treatment/api";
import { addArchivesEvent,updateArchives,archivesDetail } from "@/api/crossreentry";
import {
  getPlaceList
} from '@/views/treatment/components/CrossReferenceEntry/api.js';
export default {
  props: {
    showNewCourse: {
      type: Boolean,
      default: false
    },
    basicOcrObj: {
      type: Array,
      default: () => []
    },
    kinsFolkForm: {
      type: Object,
      default: () => {}
    },
    itemBelong: {
      type: Number
    },
    selectArchivesEvent: {
      type: Object,
      default: () => {}
    },
    ocrTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //选当前时间之前的时间
        }
      },
      eventTypeCode: {
        '门诊': 5,
        '急诊': 6,
        '住院': 7,
        '院外': 8
      },
      therapyStageInfo: [],
      therapyStageIdList: [],
      therProps: {
        value: "therapyStageId",
        label: "therapyStageName"
      },
      therapyStageList: [],
      diseaseList: [],
      dialogVisible: false,
      ruleForm: {
        hospital: '',
        departmentName: '',
        // name: "",
        // apartment: "",
        // region: "",
        // date1: "",
        // date2: "",
        // delivery: false,
        // resource: ""
        eventDate: '',
        diseaseName: ''
      },
      rules: {
        // name: [
        //   { required: true, message: "请输入治疗地点", trigger: "blur" },
        //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        // ],

        eventDate: [{ required: true, message: "请选择病程时间", trigger: "blur" }],
        hospital: [{ required: true, message: "请选择治疗地点", trigger: "blur" }],
        departmentName: [{ required: true, message: "请选择治疗科室", trigger: "blur" }],
        eventName: [{ required: true, message: "请选择治疗类型", trigger: "blur" }]
      }
    };
  },
  created() {
    // console.log(this.basicOcrObj)
    this.basicOcrObj.forEach((v,i) => {
      if (v.key_en == 'hospital') {
        this.ruleForm.hospital = this.basicOcrObj[i].value
      }
      if (v.key_en == 'departmentName') {
        this.ruleForm.departmentName = this.basicOcrObj[i].value
      }
    })
    // 赋值 病程时间
    this.ruleForm.eventDate = this.ocrTime?this.ocrTime.slice(0,11):''
    if (this.selectArchivesEvent.id) {
      this.getArchivesDetail()
    }
    // this.ruleForm.hospital = JSON.parse(this.basicOcrObj)
    // this.getArchivesDetail()
  },
  methods: {
    async getArchivesDetail() {
      let res = await archivesDetail(this.selectArchivesEvent.id)
      if (res.code === 0) {
        // console.log(res)
        this.ruleForm = res.data
        if (res.data.diseaseId) {
          this.$set(this.ruleForm,'diseaseObj',{
            diseaseId: res.data.diseaseId,
            diseaseName: res.data.diseaseName
          })
          this.getDieaseItemList(1, res.data.diseaseName);
        }
        if (res.data.therapyStageInfo.length) {
          await this.getTherapyStageList(res.data.diseaseId);
          res.data.therapyStageInfo.forEach(v => {
            if (v.therapyStageId) {
              this.therapyStageIdList.push(v.therapyStageId)
            }
            if (v.children) {
              this.therapyStageIdList.push(v.children[0].therapyStageId)
            }
          })
          this.therapyStageInfo = res.data.therapyStageInfo
        }
        
        // this.ruleForm.diseaseObj = {
        //   diseaseId: res.data.diseaseId,
        //   diseaseName: res.data.diseaseName
        // }
      }
    },
    async querySearch(queryString, cb) {
      let res = await getPlaceList({
        keyWord: queryString,
        type: 1
      });
      if (res.code === 0) {
        res.data.forEach(ele => {
          ele.value = ele.name;
        });
        this.hospitalList = res.data;
        cb(this.hospitalList);
      }
    },
    async queryDepartment(queryString, cb) {
      let res = await getPlaceList({
        keyWord: queryString,
        type: 2
      });
      if (res.code === 0) {
        res.data.forEach(ele => {
          ele.value = ele.name;
        });
        this.departmentList = res.data;
        cb(this.departmentList);
      }
    },
    async handleAddEvent() {
      let valRes
      this.$refs.eventForm.validate(val => {
        valRes = val
      })
      if (!valRes) {
        return
      }
      // console.log(this.therapyStageInfo)
      // return
      if (this.ruleForm.id) {
        let res = await updateArchives({
          ...this.ruleForm,
          // diseaseId: this.ruleForm.diseaseObj ? this.ruleForm.diseaseObj.diseaseId : null,
          // diseaseName: this.ruleForm.diseaseObj ? this.ruleForm.diseaseObj.diseaseName : null,
          // patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id
          diseaseName: this.ruleForm.diseaseName,
          patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
          eventType: this.eventTypeCode[this.ruleForm.eventName],
          therapyStageInfo: this.therapyStageInfo,
          patientRelativeId: this.itemBelong == 1 ? null : this.kinsFolkForm.id
        })
        if (res.code == 0) {
          this.$emit('closeNewCourse',this.ruleForm.id)
          this.$emit('searchArchivesEvent')
        }
      } else {
        let res = await addArchivesEvent({
          ...this.ruleForm,
          // diseaseId: this.ruleForm.diseaseObj ? this.ruleForm.diseaseObj.diseaseId : null,
          // diseaseName: this.ruleForm.diseaseObj ? this.ruleForm.diseaseObj.diseaseName : null,
          // patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id
          patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
          eventType: this.eventTypeCode[this.ruleForm.eventName],
          therapyStageInfo: this.therapyStageInfo,
          patientRelativeId: this.itemBelong == 1 ? null : this.kinsFolkForm.id
        })
        if (res.code == 0) {
          this.$emit('closeNewCourse',res.data)
          this.$emit('searchArchivesEvent')
        }
      }
      
    },
    changeTther() {
      let end = this.$refs.therCascader.getCheckedNodes()[0];
      console.log(end)
      
      if (end.level == 1) {
        // this.ruleForm.firstTherapyStageId = end.value;
        // this.ruleForm.firstTherapyStageName = end.label;
        // this.ruleForm.secondTherapyStageId = "";
        // this.ruleForm.secondTherapyStageName = "";


        this.therapyStageInfo = [{
          therapyStageName: end.label,
          therapyStageId: end.value,
          children: []
        }]
      } else {
        // this.ruleForm.secondTherapyStageId = end.value;
        // this.ruleForm.secondTherapyStageName = end.label;
        // this.ruleForm.firstTherapyStageId = end.parent.value;
        // this.ruleForm.firstTherapyStageName = end.parent.label;

        this.therapyStageInfo = [{
          therapyStageName: end.parent.label,
          therapyStageId: end.parent.value,
          children: [{
            therapyStageName: end.label,
            therapyStageId: end.value
          }]
        }]
      }
    },
    // 获取战略病种治疗阶段
    async getTherapyStageList(diseaseId) {
      let { code, data } = await getTherapyStageByDiseaseId({ diseaseId });
      if (code == 0) {
        this.therapyStageList = data
          ? data.map(item => {
              if (item.children && item.children.length == 0) {
                item.children = null;
              }
              if (item.children && item.children.length > 0) {
                item.children.map(items => {
                  if (items.children && items.children.length == 0) {
                    items.children = null;
                  }
                });
              }
              if (item.therapyStageName === this.ruleForm.therapyStage) {
                this.ruleForm.therapyStageObj = item;
              }
              return item;
            })
          : [];
      }
    },
    async getDieaseItemList(current, searchCondition) {
      let res = await findDiseaseTypeByAdmin({
        current: current,
        size: 20,
        conditionName: searchCondition
      });
      if (res.code == 0) {
        res.data.records.map(v => {
          v.diseaseId = v.id
          v.diseaseName = v.suborderName
        })
        this.diseaseList = this.diseaseList.concat(res.data.records);
        this.dieasePages = res.data.pages;
      }
    },
    remoteDieaseItemMethod(query) {
      this.diseaseList = [];
      this.dieaseCurrent = 1;
      if (query !== "") {
        this.itemQuery = query;
        this.getDieaseItemList(1, query);
      } else {
        this.diseaseList = [];
      }
    },
    //加载病种
    loadmore() {
      this.dieaseCurrent++;
      if (this.dieaseCurrent > this.dieasePages) {
        return;
      }
      this.getDieaseItemList(this.dieaseCurrent, this.itemQuery);
    },
    diseaseNameChange(value) {
      this.therapyStageInfo = []
      // // 获取治疗阶段
      // this.ruleForm.therapyStage = "";
      // this.ruleForm.therapyStageId = ''
      // this.ruleForm.firstTherapyStageId = ''
      // this.ruleForm.firstTherapyStageName = ''
      // this.ruleForm.secondTherapyStageId = ''
      // this.ruleForm.secondTherapyStageName = ''
      this.getTherapyStageList(value.diseaseId);
    },
    closeAddEvent() {
      this.$emit('closeNewCourse')
    },
    handleClose(done) {
      this.$emit('closeNewCourse')
      // this.$confirm("确认关闭？")
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    }
  }
};
</script>

<style lang="less" scoped>
.common-sty {
  width: 100%;
}
.dialog-footer {
  text-align: center;
}
</style>